import React from 'react';
import { CardTitle, Card, CardContent, Input, withGrid, Textarea, Button } from '../../../Components';
import { MonografiaModel } from '../../../Store';
import { media } from '../../../Themes';
import styled from 'styled-components';
import { format } from 'date-fns';

interface IAgendamentoProps {
  monografia: MonografiaModel;
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const ButtonGrid = styled(Button) <any>`
  grid-column: ${p => p.gridColumn};
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const TextAreaGrid = styled(Textarea) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

export default function DetalhesMonografia(props: IAgendamentoProps) {
  const { monografia } = props;
  const depositoDownload = `${process.env.REACT_APP_API_URL}arquivo/${monografia!.deposito!.identifier}`;

  return (
    <Card>
      <CardTitle>Informações do TCC</CardTitle>
      <CardContentGrid>
        <InputGrid
          gridColumn='1/8'
          name='nome'
          label='Nome do Aluno'
          disabled={true}
          value={monografia.aluno.nome}
        />
        <InputGrid
          gridColumn='8/14'
          name='email'
          label='Email do Aluno'
          disabled={true}
          value={monografia.aluno.email}
        />
        <TextAreaGrid
          gridColumn='1/14'
          name='titulo'
          label='Titulo'
          disabled={true}
          value={monografia.titulo}
        />
        <InputGrid
          gridColumn='1/14'
          name='dataDeposito'
          label="Data do Depósito"
          disabled={true}
          value={format(monografia!.deposito!.dataDoDeposito, 'DD/MM/YYYY')}
        />
        <ButtonGrid
          gridColumn='10/14'
          onClick={() => window.open(depositoDownload)}
        >
          Baixar TCC
        </ButtonGrid>
      </CardContentGrid>
    </Card>
  );
}
